import { OrganisationDataDto } from '@dhl/mdp-api'
import type { OrganisationData } from '~/modules/organisations/model'
import { convertToAddressDto } from '~/common/components/addresses'
import { convertToContactPersonDto } from '~/common/model/contact'

export const convertToOrganisationDataDto = (organisationData: OrganisationData): OrganisationDataDto => ({
  ...organisationData,
  address: convertToAddressDto(organisationData.address),
  contactPerson: convertToContactPersonDto(organisationData.contactPerson),
})
